const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

function getToken() { return localStorage.getItem('syenovix_token'); }

async function req(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Request failed');
  }
  return res.json();
}

export const api = {
  // Auth
  login:  (email, password) => req('/api/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  setup:  (email, password) => req('/api/auth/setup', { method: 'POST', body: JSON.stringify({ email, password }) }),

  // Public
  getStats:       () => req('/api/stats'),
  getBlogPosts:   () => req('/api/blog'),
  getBlogPost:    (id) => req(`/api/blog/${id}`),
  getTestimonials:() => req('/api/testimonials'),
  getCaseStudies: () => req('/api/casestudies'),

  // Admin — blog
  adminGetAllPosts:  () => req('/api/blog/all'),
  createPost:   (data) => req('/api/blog',      { method: 'POST', body: JSON.stringify(data) }),
  updatePost: (id, data) => req(`/api/blog/${id}`, { method: 'PUT',  body: JSON.stringify(data) }),
  deletePost:    (id) => req(`/api/blog/${id}`, { method: 'DELETE' }),

  // Admin — testimonials
  createTestimonial: (data) => req('/api/testimonials',      { method: 'POST', body: JSON.stringify(data) }),
  updateTestimonial:(id,data)=> req(`/api/testimonials/${id}`,{ method: 'PUT',  body: JSON.stringify(data) }),
  deleteTestimonial: (id) => req(`/api/testimonials/${id}`, { method: 'DELETE' }),

  // Admin — case studies
  createCaseStudy: (data) => req('/api/casestudies',       { method: 'POST', body: JSON.stringify(data) }),
  updateCaseStudy:(id,data)=> req(`/api/casestudies/${id}`,{ method: 'PUT',  body: JSON.stringify(data) }),
  deleteCaseStudy: (id) => req(`/api/casestudies/${id}`,  { method: 'DELETE' }),

  // Admin — stats
  updateStats: (data) => req('/api/stats', { method: 'PUT', body: JSON.stringify(data) }),

  // Config — all page sections
  getConfig:        (key)      => req(`/api/config/${key}`),
  updateConfig:     (key,data) => req(`/api/config/${key}`, { method: 'PUT', body: JSON.stringify(data) }),
  getHero:          ()         => req('/api/config/hero'),
  getServices:      ()         => req('/api/config/services'),
  getMethodology:   ()         => req('/api/config/methodology'),
  getAICapabilities:()         => req('/api/config/ai_capabilities'),
  getIndustries:    ()         => req('/api/config/industries'),
  getAboutValues:   ()         => req('/api/config/about_values'),

  // Enquiries
  submitEnquiry:     (data)    => req('/api/enquiries',          { method: 'POST',  body: JSON.stringify(data) }),
  getEnquiries:      ()        => req('/api/enquiries'),
  markEnquiryRead:   (id)      => req(`/api/enquiries/${id}/read`,{ method: 'PATCH' }),
  deleteEnquiry:     (id)      => req(`/api/enquiries/${id}`,    { method: 'DELETE' }),

  // Auth extras
  forgotPassword:  (email)           => req('/api/auth/forgot-password',  { method: 'POST', body: JSON.stringify({ email }) }),
  resetPassword:   (token, password) => req('/api/auth/reset-password',   { method: 'POST', body: JSON.stringify({ token, password }) }),
  changePassword:  (currentPassword, newPassword) => req('/api/auth/change-password', { method: 'POST', body: JSON.stringify({ currentPassword, newPassword }) }),

  // Admin users
  getAdmins:    ()            => req('/api/admins'),
  createAdmin:  (data)        => req('/api/admins',      { method: 'POST',   body: JSON.stringify(data) }),
  deleteAdmin:  (id)          => req(`/api/admins/${id}`,{ method: 'DELETE' }),

  // Clients (TrustedBy)
  getClients:   ()            => req('/api/clients'),
  createClient: (data)        => req('/api/clients',      { method: 'POST',   body: JSON.stringify(data) }),
  updateClient: (id,data)     => req(`/api/clients/${id}`,{ method: 'PUT',    body: JSON.stringify(data) }),
  deleteClient: (id)          => req(`/api/clients/${id}`,{ method: 'DELETE' }),

  // Testimonial submissions (public)
  submitTestimonial:  (data)  => req('/api/testimonials/submit',         { method: 'POST',  body: JSON.stringify(data) }),
  adminGetAllTestimonials: () => req('/api/testimonials/all'),
  approveTestimonial: (id,status) => req(`/api/testimonials/${id}/status`,{ method: 'PATCH', body: JSON.stringify({ status }) }),
};
